


import React from 'react';

const Services = () => {
    const headingStyle = {
        textAlign: 'center',
        fontSize: '2em',
        marginBottom: '30px',
        marginTop: '44px', // Added margin top
        fontFamily: 'roboto',
    };

    const spanStyle = {
        color: 'orange',
    };

    return (
        <div>
            <style>
                {`
                .service-card {
                    padding: 20px;
                    border: 2px solid #ccc; /* Default border */
                    background-color: #f9f9f9;
                    flex: 1; /* Ensure all cards take up equal space */
                    max-width: 25%; /* Each card takes up 25% width on large screens */
                    transition: transform 0.3s, box-shadow 0.3s, background-color 0.3s, border-color 0.3s, border-width 0.3s;
                    text-align: center;
                    position: relative;
                    margin: 5px; /* Add space between cards */
                    color: #333; /* Default text color */
                    margin-top: 33px;
                }

                .service-card:hover {
                    transform: scale(1.05) rotate(-2deg);
                    box-shadow: 0 8px 15px rgba(0, 0, 0, 0.3);
                    background-color: black; /* Background turns black */
                    color: white; /* Text turns white */
                    border-color: orange; /* Border turns orange */
                    border-width: 2px; /* Border becomes thicker */
                }

                .service-card:hover h1 {
                    color: orange; /* Heading turns orange on hover */
                }

                .service-card h1 {
                    font-size: 20px;
                    margin-bottom: 10px;
                    transition: color 0.3s; /* Smooth color transition for heading */
                }

                .service-card p {
                    font-size: 17px;
                    font-family: roboto;
                    color: black; /* Default paragraph text color */
                    transition: color 0.3s; /* Smooth color transition for paragraph */
                }

                .service-card:hover p {
                    color: white; /* Paragraph text turns white on hover */
                }

                .card-container {
                    display: flex;
                    flex-wrap: wrap; /* Allow wrapping on smaller screens */
                    justify-content: space-between; /* Distribute cards evenly */
                    gap: 10px; /* Space between cards */
                    margin: 20px 0;
                }

                /* Responsive Styles */
                @media (max-width: 1200px) {
                    .service-card {
                        max-width: 45%; /* Adjust card width for medium screens */
                    }
                }

                @media (max-width: 768px) {
                    .card-container {
                        flex-direction: column; /* Stack cards vertically on smaller screens */
                        margin-left:20px;
                    }

                    .service-card {
                        max-width: 100%; /* Full-width cards on mobile */
                        margin: 10px 0; /* Add space between stacked cards */
                    }
                }

                @media (max-width: 480px) {
                    .service-card h1 {
                        font-size: 18px; /* Smaller font for headings */
                    }

                    .service-card p {
                        font-size: 15px; /* Smaller font for paragraphs */
                    }
                }
                `}
            </style>

            <div className="row d-flex justify-content-center" style={{width:'100%',}}>
                <div className="col-md-10">
                    {/* Title Section */}
                    <h3 style={headingStyle}>
                        WHAT YOU WILL <span style={spanStyle}>GAIN</span>
                    </h3>

                    {/* Cards Section */}
                    <div className="card-container">
                        {/* Display all 4 service cards */}
                        <div className="service-card">
                            <h1>Understanding of Digital Factory Technologies</h1>
                            <p>
                            Learn how automation, robotics, sensors, and cloud computing are integrated into modern factories to create smart manufacturing systems.
                            </p>
                        </div>
                        <div className="service-card">
                            <h1>Practical Skills:</h1>
                            <p>
                            Gain hands-on experience with the tools and platforms used in digital factories, such as simulation software, automation systems, and data analysis tools.
                            </p>
                        </div>
                        <div className="service-card">
                            <h1>Efficiency Gains</h1>
                            <p>
                            Understand how digital solutions can help reduce errors, optimize workflows, and enhance collaboration between teams on the factory floor.
                            </p>
                        </div>
                        <div className="service-card">
                            <h1>Career Growth:</h1>
                            <p>
                            Develop skills that will open doors to roles in smart manufacturing, automation engineering, and digital factory management.
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Services;


